import React from 'react';

const EnqueteIco = () => {
  return (
    <svg width="1.5rem" height="1.5rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 557 386.4">
      <path d="M156.1,0h387.4c7.5,0,13.5,6,13.5,13.4c0,0,0,0,0,0v62.6c0,7.5-6,13.5-13.5,13.5c0,0,0,0,0,0H156.1c-7.5,0-13.5-6-13.5-13.5
	V13.5C142.6,6,148.6,0,156.1,0z"/>
      <path d="M156.1,151.2h269.8c7.5,0,13.5,6,13.5,13.5c0,0,0,0,0,0v62.6c0,7.5-6,13.5-13.5,13.5H156.1c-7.5,0-13.5-6-13.5-13.5v-62.6
	C142.6,157.2,148.6,151.2,156.1,151.2L156.1,151.2z"/>
      <path d="M156.1,296.8h118.6c7.5,0,13.5,6,13.5,13.5c0,0,0,0,0,0v62.6c0,7.5-6,13.5-13.5,13.5H156.1c-7.5,0-13.5-6-13.5-13.5v-62.6
	C142.6,302.8,148.6,296.8,156.1,296.8z"/>
      <path d="M88.4,44.7c0,24.4-19.8,44.2-44.2,44.2S0,69.1,0,44.7S19.8,0.5,44.2,0.5c0,0,0,0,0,0C68.6,0.5,88.4,20.3,88.4,44.7" />
      <path d="M88.4,196.5c0,24.4-19.8,44.2-44.2,44.2S0,220.9,0,196.5s19.8-44.2,44.2-44.2c0,0,0,0,0,0C68.6,152.3,88.4,172.1,88.4,196.5
	C88.4,196.5,88.4,196.5,88.4,196.5"/>
      <path d="M88.4,339.6c0,24.4-19.8,44.2-44.2,44.2S0,364,0,339.6s19.8-44.2,44.2-44.2c0,0,0,0,0,0C68.6,295.4,88.4,315.2,88.4,339.6
	C88.4,339.6,88.4,339.6,88.4,339.6"/>
    </svg>

  )
}

export default EnqueteIco;